import React from 'react';
import { Table, Button, Popconfirm } from 'antd';
import { configManager } from '@unicus/react-ui-kit';

const ListTable = (props) => {
  const {
    dataSource,
    loading,
    pagination: incomingPagination,
    children,
    initEditing,
    initCreation,
    rowSelection,
    rowClassName,
    className,
    handleTableChange,
    columns,
    components,
    moveRow,
    onDoubleClick,
    removeRecord,
    showHeader,
    showActions = true,
    actionsComponent: ActionsComponent,
    header = null,
    filter,
    showPagination = true,
    doubleClick = true,
    expandable,
    title,
    ...rest
  } = props;

  // antd's Table `title` prop must be a function `(currentData) => ReactNode`.
  // Pages that spread `{...props}` (route config) into ListTable leak a string
  // `title`, which rc-table then calls as a function -> "title is not a function"
  // and a blank screen. Only forward `title` when it is actually a function.
  const tableTitle = typeof title === 'function' ? title : undefined;

  let pagination = incomingPagination;

  if (!showPagination || pagination?.pageCount === 1) {
    pagination = false;
  }

  const handleDoubleClick = (record) => {
    if (!doubleClick) {
      return;
    }

    if (onDoubleClick) {
      onDoubleClick(record);
    } else if (initEditing) {
      initEditing(record);
    }
  };

  if (
    Array.isArray(columns) &&
    showActions &&
    !columns.some((c) => c.key === 'action')
  ) {
    columns.push({
      key: 'action',
      align: 'right',
      width: '40px',
      render: (_, record) =>
        ActionsComponent ? (
          <ActionsComponent
            record={record}
            initEditing={initEditing}
            initCreation={initCreation}
            removeRecord={removeRecord}
          />
        ) : (
          <>
            <Button size="small" onClick={() => initEditing(record)}>
              Editar
            </Button>
            <Popconfirm
              title="Deseja excluir?"
              onConfirm={() => removeRecord(record.id)}
              cancelText="Não"
              okText="Sim"
            >
              <Button type="danger" size="small">
                Excluir
              </Button>
            </Popconfirm>
          </>
        )
    });
  }

  const wrapperFilter = (array) => {
    if (filter) {
      return array.filter(filter);
    }

    return array;
  };

  return (
    <>
      {header}
      <Table
        scroll={{ x: 400 }}
        size={configManager.getConfig().layout.list.table.size}
        className={className}
        loading={loading}
        rowKey={(record) => record.id ?? record.uuid}
        rowSelection={rowSelection}
        pagination={pagination}
        onChange={handleTableChange}
        dataSource={wrapperFilter(dataSource)}
        rowClassName={rowClassName}
        showHeader={showHeader}
        columns={columns}
        expandable={expandable}
        title={tableTitle}
        locale={{ emptyText: 'Nenhum registro para exibir' }}
        components={components}
        {...rest}
        onRow={(record, index) => {
          return {
            onDoubleClick: () => handleDoubleClick(record),
            index,
            moveRow
          };
        }}
      >
        {typeof children === 'function'
          ? children({ initEditing, removeRecord, initCreation })
          : children}
      </Table>
    </>
  );
};

export default ListTable;
